class ModalManager {
  constructor(el) {
    this.el = el;
    this.body = document.getElementsByTagName("BODY")[0];
  }

  openModal = () => {
    // console.log("openModal");
    this.body.appendChild(this.el);
  };

  closeModal = () => {
    // console.log("closeModal");
    this.body.removeChild(this.el);
  };

  createOpenButtons = () => {
    // create a tag and copy
    const buttonEls = document.getElementsByClassName("open-modal");

    // activate
    for (let i = 0; i < buttonEls.length; i++) {
      const element = buttonEls[i];
      element.addEventListener("click", this.openModal);
    }
  };

  createCloseButton = () => {
    // create a tag and copy
    const buttonEls = this.el.getElementsByClassName("close-modal");

    // activate
    for (let i = 0; i < buttonEls.length; i++) {
      const element = buttonEls[i];
      element.addEventListener("click", this.closeModal);
    }
  };

  init = () => {
    this.closeModal();
    this.el.classList.add("active");
    this.createOpenButtons();
    this.createCloseButton();
  };
}

export default ModalManager;
